var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZapFastIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.513 23.654H5.18m4-7.334h-6m9.333-7.333H5.846M23.18 4.32l-8.796 12.314c-.389.545-.584.817-.575 1.044a.667.667 0 00.259.503c.18.14.515.14 1.184.14h6.594l-1.333 10 8.795-12.314c.39-.545.584-.818.576-1.045a.667.667 0 00-.26-.503c-.18-.139-.514-.139-1.184-.139h-6.594l1.334-10z",
    stroke: "#2C5BFF",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/landing/zap-fast-icon-52d98c87.svg";
export { SvgZapFastIcon as ReactComponent };